import styled from 'styled-components';

export const BannerContent = styled.div`
  --color-primary: #008ab5;
  --color-secondary: #263f6d;

  .banner-section {
    position: relative;
    background: #ff0037;
    overflow: hidden;

    .mobile-only {
      background: #c40023;
      border: 1px solid #c40023;
      color: #ffffff;

      @media (min-width: 600px) {
        display: none;
      }
    }

    .full-width-image {
      height: 100vh;
      min-height: 630px;
      max-height: 655px;
      align-items: flex-start;
      justify-content: flex-start;

      .container {
        margin: 100px 17px;

        .title {
          font-family: 'Arial', sans-serif;
          font-weight: bold;
          font-size: 36px;
          line-height: 46px;
          margin-bottom: 40px;
          color: #ffffff;
        }

        .subtitle {
          font-family: 'Arial', sans-serif;
          font-weight: 400;
          font-size: 18px;
          line-height: 27px;
          margin-bottom: 40px;
          color: #ffffff;
        }

        button {
          justify-content: center;
          font-weight: 700;
          width: 100%;
          margin-bottom: 16px;

          &.outline {
            background: #ffffff;
            color: #c40023;
          }
        }
      }

      @media (min-width: 600px) {
        .container {
          margin: 110px 40px;

          .title {
            font-size: 48px;
            line-height: 62px;
            max-width: 442px;
          }

          .subtitle {
            font-size: 22px;
            line-height: 33px;
            max-width: 318px;
          }

          button {
            max-width: 212px;
            width: 100%;
          }
        }
      }

      @media (min-width: 1024px) {
        .container {
          margin: 150px auto;

          .title {
            font-size: 56px;
            line-height: 72px;
            max-width: 587px;
          }

          .subtitle {
            max-width: 587px;
          }
        }
      }
    }

    .bottom-button {
      display: flex;
      justify-content: center;
      margin-top: -60px;
      padding-bottom: 10px;
      opacity: 0.5;

      svg {
        cursor: pointer;
      }
    }
  }
`;

export const DefaultBackgroundImage = styled.div`
  width: 100%;
  height: 88%;
  position: absolute;
  background-image: url('./img/default-background.png');
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: contain;
  mix-blend-mode: multiply;
  bottom: 0;

  @media (min-width: 600px) {
    right: -100px;
    height: 56%;
  }

  @media (min-width: 1024px) {
    height: 64%;
    right: -100px;
  }

  @media (min-width: 1280px) {
    right: -155px;
    height: 84%;
  }

  @media (min-width: 1600px) {
    height: 100%;
  }

`;
